import styled from 'styled-components';

export const StyledPlaySimpleBalance = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  min-height: 25px;
  font-family: var(--font-family);
  width: max-content;

  .playSimple-balance {
    position: relative;

    &__img {
      position: absolute;
      height: 22px;
      aspect-ratio: 1/1;
      margin-right: 0.5em;
      background-color: #000;
      border-radius: 50%;
      padding: 1px;
    }

    &__amount {
      height: 20px;
      display: flex;
      align-items: center;
      padding: 0 8px 0 28px;
      background: #000;
      border-radius: 16px;
      color: #ffffff;
    }
  }
` as any;
